import { render } from "./LichSuGiaoNhan.vue?vue&type=template&id=59bcd6b2&scoped=true"
import script from "./LichSuGiaoNhan.vue?vue&type=script&lang=js"
export * from "./LichSuGiaoNhan.vue?vue&type=script&lang=js"

import "./LichSuGiaoNhan.vue?vue&type=style&index=0&id=59bcd6b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bcd6b2"]])

export default __exports__